/**
 * @file entry of form components
 * @author chenqiang(chenqiang03)
 */
import InternalForm, { useForm } from './Form';
import Item from './FormItem';
import ErrorList from './ErrorList';
import List from './FormList';
import { FormProvider } from './context';
import devWarning from '../_util/devWarning';
var Form = InternalForm;
Form.Item = Item;
Form.List = List;
Form.ErrorList = ErrorList;
Form.useForm = useForm;
Form.Provider = FormProvider;
Form.create = function () {
  devWarning(false, 'Form', '`Form.create` is deprecated.');
};
export default Form;